export default "__VITE_ASSET__hwWj1Y0X__"